import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import {ClientService} from '../../../Services/client.service';
import {AuthService} from '../../../auth/AuthService';
import {debounceTime, distinctUntilChanged, first, finalize } from 'rxjs/operators';
import swal from 'sweetalert2';
import {ActivatedRoute, Router} from '@angular/router';
import {PatientService} from '../../../Services/patient.service';
import {IPatient, IMedicalInsurance, PatientBenefitType} from '../../../Model/Patient';
import {DatePipe} from '@angular/common';
import {statesDropdown} from '../../../shared/StatesUS';
import {ProviderService} from '../../../Services/provider.service';

interface Phone {
    phoneType?: string | null;
    number?: string | null;
}
@Component({
    selector: 'pm-add-update-patient',
    templateUrl: './add-update-patient.component.html',
    styleUrls: ['./add-update-patient.component.css'],
    providers: [DatePipe],
})


export class AddUpdatePatientComponent implements OnInit {
    pRegisterForm!: FormGroup;
    patientId: any;
    status: any;
    readonly benefitTypes = ['DENTAL', 'MEDICAL', 'BOTH'];
    private existingDentalInsurance = false;
    private existingMedicalInsurance = false;
    private originalBenefitType: PatientBenefitType = 'DENTAL';
    // reRunBatchJob: boolean;
    isReEvaluating = false;
    isExternalUser = false;
    agentArray: any = [];
    filterAgentArray = [...this.agentArray];
    today: Date = new Date();
    iTypeArray: any = [
        {value: 'Primary', viewValue: 'Primary'},
        {value: 'Secondary', viewValue: 'Secondary'},
    ];

    urgencyArray: any = [
        {value: 'URGENT', viewValue: 'Urgent'},
        {value: 'NORMAL', viewValue: 'Normal'},
    ];

    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];

    relationshipArray:any = [
        {value: 'SPOUSE', viewValue: 'Spouse'},
        {value: 'SELF', viewValue: 'Self'},
        {value: 'CHILD', viewValue: 'Child'},
        {value: 'OTHER_ADULT', viewValue: 'Other-Adult'},
    ];
    fType: any = [
      {value: 'selectForm', viewValue: 'Select Form Type'},
      {value: 'FULL FORM', viewValue: 'FULL FORM'},
      {value: 'SHORT FORM', viewValue: 'SHORT FORM'},
      {value: 'ELIG CHECK', viewValue: 'ELIG CHECK'},
    ];
    providerArray:any= [];
    payerArray: any[] = [];
    filteredPayers: any[] = [];
    selectedPayer: any = null;
    payerSearchControl = new FormControl('');
    payerSearchLoading = false;
    private readonly MAX_PAYER_RESULTS = 100;
    OfficeType:any =[];


    stateList:any = statesDropdown

    @ViewChild('time') inputElementRef!: ElementRef;


    constructor(private fb: FormBuilder,
                private patientService: PatientService,
                private clientServices: ClientService,
                private authService: AuthService,
                private activatedRoute: ActivatedRoute,
                private providerServices: ProviderService,
                private datePipe: DatePipe,
                private route: Router,
                private cdr: ChangeDetectorRef) {

        this.patientId = this.activatedRoute.snapshot.paramMap.get('id');

        this.pRegisterForm = this.fb.group({
            id: [],
            firstName: [null, Validators.required],
            lastName: [null, [Validators.required]],
            benefitType: ['DENTAL', Validators.required],
            medicalInsurance: this.createMedicalInsurance(),
            payer:[null, Validators.required],
            //carrierName: [null,Validators.required],
            gender: [null],
            dob: [null, [Validators.required]],
            email: [null, [Validators.email]],
            appointmentDate: [null, Validators.required],
            appointmentTime: [null, Validators.required],
            ssn: [null, Validators.pattern(/^\d{9}$|^\d{3}-\d{2}-\d{4}$/)],
            firstLine: [null],
            secondLine: [null],
            city: [null],
            state: [null],
            zip: [null,Validators.pattern(/^\d{5}(?:[-\s]?\d{4})?$/)],
            number: [null,Validators.pattern(/^\d{10}$|^\d{3}-\d{3}-\d{4}$/)],
            phoneType: [null],
            insuranceType: [null,Validators.required],
            insurancePhoneNo: [null,Validators.pattern(/^\d{10}$|^\d{3}-\d{3}-\d{4}$/)],
            //officeName: [null],
            //providerName: [null],
            groupName: [null],
            groupNo: [null],
            memberId: [null, Validators.required],
            relationship: [null, Validators.required],
            providerId: [null, Validators.required],
          //  payerId: [null, Validators.required],
            isSubscriber: [false],
            isChecked:[null],
            patientId:[null,Validators.required],
            subscriberFName: [null,Validators.required],
            subscriberLName: [null,Validators.required],
            subscriberDOB: [null,Validators.required],
            officeId : [null, Validators.required],
            formType : [null, Validators.required],
            userId: [null],
            urgency:['NORMAL']
            // reRunBatchJob: [null],
            });

            this.pRegisterForm.get('isChecked')?.disable();
    }

    ngOnInit(): void {
        this.isExternalUser = this.authService.isExternalUser();
        this.onBenefitTypeChange('DENTAL');
        this.initializePayerSearch();

        if (this.isExternalUser && !this.patientId) {
            this.pRegisterForm.controls.urgency.setValue('URGENT');
        }

        this.getRequiredList().then(() => {
            if (this.patientId) {
                this.loadPatientDetails();
            }
        });

        let params = {
            isOfficeNameAndId: true,
            clientId: this.authService.clientId
        };

        this.providerServices
            .getAllOffice(params)
            .pipe(first())
            .subscribe((response: any) => {

                this.OfficeType = Array.isArray(response) ? response : [];

                // Auto-select office when only one office is available
                if (
                    this.OfficeType.length === 1 &&
                    !this.pRegisterForm.get('officeId')?.value
                ) {
                    this.pRegisterForm.patchValue({
                        officeId: this.OfficeType[0].id
                    });
                }
            });
        this.getAgents();
    }

    async getRequiredList(): Promise<void> {
    const providerParams = {
        isProviderNameAndId: true,
        clientId: this.authService?.clientId ?? null
    };

    try {
        const providerResponse: any =
            await this.patientService
                .getAllProvider(providerParams)
                .pipe(first())
                .toPromise();

        this.providerArray = Array.isArray(providerResponse)
            ? providerResponse
            : [];

    } catch (error) {
        const err : any = error;
        this.providerArray = [];

        this.showError(
            err?.error?.message ||
            'Failed to fetch provider list'
        );
    }

    const payerParams = {
        isPayerNameAndId: true,
        clientId: this.authService?.clientId ?? null
    };

    try {
        this.payerSearchLoading = true;

        const payerResponse: any =
            await this.patientService
                .getPayer(payerParams)
                .pipe(first())
                .toPromise();

        this.payerArray = Array.isArray(payerResponse)
            ? payerResponse
            : [];

        // Sort payer list once after loading
        this.payerArray.sort((a: any, b: any) =>
            String(a?.name || '').localeCompare(
                String(b?.name || '')
            )
        );

        // Only render a limited number initially
        this.filteredPayers = this.payerArray.slice(
            0,
            this.MAX_PAYER_RESULTS
        );

    } catch (error) {
        const err: any = error;
        this.payerArray = [];
        this.filteredPayers = [];

        this.showError(
            err?.error?.message ||
            'Failed to fetch payer list'
        );

    } finally {
        this.payerSearchLoading = false;
    }
    }

    private initializePayerSearch(): void {

    this.payerSearchControl.valueChanges
        .pipe(
            debounceTime(200),
            distinctUntilChanged()
        )
        .subscribe((value: any) => {

            // Autocomplete selection returns the full payer object.
            // Don't run another text search in that case.
            if (value && typeof value === 'object') {
                return;
            }

            this.filterPayers(value || '');
        });
    }
    private filterPayers(searchValue: string): void {

    const search = String(searchValue || '')
        .trim()
        .toLowerCase();

    if (!search) {
        /*
         * Do not render all 1800+ items when the dropdown first opens.
         */
        this.filteredPayers =
            this.payerArray.slice(0, this.MAX_PAYER_RESULTS);

        return;
    }

    this.filteredPayers = this.payerArray
        .filter((payer: any) => {

            const name =
                String(payer?.name || '').toLowerCase();

            const payerId =
                String(payer?.payerIdCode || '').toLowerCase();

            return (
                name.includes(search) ||
                payerId.includes(search)
            );
        })
        .slice(0, this.MAX_PAYER_RESULTS);
    }
    onPayerSelected(payer: any): void {

    if (!payer) {
        return;
    }

    this.selectedPayer = payer;

    this.pRegisterForm
        .get('payer')
        ?.setValue(payer.id);

    this.pRegisterForm
        .get('payer')
        ?.markAsTouched();
    }
    displayPayer = (payer: any): string => {
    return payer?.name || '';
    };
    onPayerSearchFocus(): void {

    if (!this.payerSearchControl.value) {
        this.filteredPayers =
            this.payerArray.slice(
                0,
                this.MAX_PAYER_RESULTS
            );
    }
    }

    async loadPatientDetails() {
        const reqData = { patientId: this.patientId, clientId: this.authService.clientId };

        try {
            const response = await this.patientService.getPatientDetails(reqData).pipe(first()).toPromise();
                if (!response) {
                    this.showError('Patient details not found!');
                    return;
                }
                let data = response;
                this.status = data?.active || false;
                // this.today = data.bookedSlots[0]?.timeSlot?.date
                //     ? new Date(data.bookedSlots[0]?.timeSlot?.date)
                //     : null;
                    const dentalInsurance = data?.primaryIns || data?.secondaryIns || null;
                    const medicalInsurance = data?.medicalInsurance || null;
                    const hasDental = !!dentalInsurance;
                    const hasMedical = !!medicalInsurance;
                    this.existingDentalInsurance = hasDental;
                    this.existingMedicalInsurance = hasMedical;
                    this.originalBenefitType = hasDental && hasMedical ? 'BOTH' : hasMedical ? 'MEDICAL' : 'DENTAL';
                    const patientPayer = dentalInsurance?.payer || medicalInsurance?.payer || null;
                    const payerId =  patientPayer?.id ?? null;
                    let selectedPayer = null;

                    if (payerId != null) {

                        selectedPayer = this.payerArray.find(
                            (payer: any) =>
                                String(payer.id) === String(payerId)
                        );

                        /*
                        * If the patient's payer is not in the master payer list,
                        * still display the payer returned by patient details.
                        */
                        if (!selectedPayer && patientPayer) {
                            selectedPayer = patientPayer;
                        }
                    }

                    this.selectedPayer = selectedPayer;

            
                this.pRegisterForm.patchValue({
                payer: payerId,
                benefitType: this.originalBenefitType,

                id: data?.id,
                firstName: data?.firstName || null,
                lastName: data?.lastName || null,
                gender: data?.gender || null,

                dob:
                    data?.dob
                        ? new Date(data.dob)
                        : null,

                email:
                    data?.contact?.email || null,

                appointmentDate:
                    data?.bookedSlots?.[0]?.timeSlot?.date
                        ? new Date(
                            data.bookedSlots[0].timeSlot.date
                        )
                        : null,

                appointmentTime:
                    data?.bookedSlots?.[0]?.timeSlot?.startTime
                        ? this.convertTo24HourFormat(
                            data.bookedSlots[0].timeSlot.startTime
                        )
                        : null,

                ssn: data?.ssn || null,

                firstLine:
                    data?.address?.firstLine || null,

                secondLine:
                    data?.address?.secondLine || null,

                city:
                    data?.address?.city || null,

                state:
                    data?.address?.state || null,

                zip:
                    data?.address?.zip || null,

                number:
                    data?.contact?.phones?.[0]?.number || null,

                phoneType:
                    data?.contact?.phones?.[0]?.phoneType || null,

                insuranceType:
                    data?.primaryIns?.insuranceType ||
                    data?.secondaryIns?.insuranceType ||
                    null,

                insurancePhoneNo:
                    data?.primaryIns?.contact?.phones?.[0]?.number ||
                    data?.secondaryIns?.contact?.phones?.[0]?.number ||
                    null,

                groupName:
                    data?.primaryIns?.groupName ||
                    data?.secondaryIns?.groupName ||
                    null,

                groupNo:
                    data?.primaryIns?.groupNo ||
                    data?.secondaryIns?.groupNo ||
                    null,

                memberId:
                    data?.memberId || null,

                relationship:
                    data?.relationship || null,

                providerId:
                    data?.providerId || null,

                isSubscriber:
                    data?.isSubscriber || false,

                subscriberFName:
                    data?.subscriber?.firstName || null,

                subscriberLName:
                    data?.subscriber?.lastName || null,

                subscriberDOB:
                    data?.subscriber?.dob
                        ? this.datePipe.transform(
                            data.subscriber.dob,
                            'MM/dd/yyyy'
                        )
                        : null,

                patientId:
                    data?.patientId || null,

                officeId:
                    data?.officeId || null,

                formType:
                    data?.primaryIns?.formType ||
                    data?.secondaryIns?.formType ||
                    null,

                userId:
                    data?.userId || null,

                urgency:
                    this.isExternalUser
                        ? 'URGENT'
                        : data?.urgency || 'NORMAL'
                });
                this.medicalInsurance.patchValue({ ...medicalInsurance, payerId: medicalInsurance?.payer?.id ?? null });
                this.onBenefitTypeChange(this.originalBenefitType);
                if (selectedPayer) {

                    this.payerSearchControl.setValue(
                        selectedPayer,
                        {
                            emitEvent: false
                        }
                    );

                    this.filteredPayers = [
                        selectedPayer,
                        ...this.payerArray
                            .filter(
                                (payer: any) =>
                                    String(payer.id) !==
                                    String(selectedPayer.id)
                            )
                            .slice(
                                0,
                                this.MAX_PAYER_RESULTS - 1
                            )
                    ];
                }
             else {
                this.showError('Patient details not found!');
            }
        } catch (error) {
            const err: any = error;
            this.showError(err.error?.message || 'An error occurred while loading patient details.');
        }
    }




    showError(message: string) {
        swal.fire({
            title: 'Error!',
            icon: 'error',
            text: message,
            showConfirmButton: false,
            timer: 5000,
        });
    }


    trackByFn(index: number, item: any) {
        return item.id;
    }

    clearPayerSelection(): void {

    this.selectedPayer = null;

    this.pRegisterForm
        .get('payer')
        ?.setValue(null);

    this.payerSearchControl.setValue('');

    this.filteredPayers =
        this.payerArray.slice(
            0,
            this.MAX_PAYER_RESULTS
        );

    this.pRegisterForm
        .get('payer')
        ?.markAsTouched();
    }

    // Change status
    changeStatus(status: any) {
        if (status == true) {
            this.status = false;
        } else {
            this.status = true;
        }
    }
    // changeBatchStatus(reRunBatchJob: any) {
    //     if (reRunBatchJob == true) {
    //         this.pRegisterForm.controls.reRunBatchJob.setValue(false)
    //     } else {
    //         this.pRegisterForm.controls.reRunBatchJob.setValue(true)
    //     }
    // }

    formatTimeTo12Hour(timeString: string): string | null {
    if (!timeString) {
        return null;
    }

    const [hoursString, minutesString] = timeString.split(':');

    let hours = Number(hoursString);
    const minutes = Number(minutesString);

    if (
        Number.isNaN(hours) ||
        Number.isNaN(minutes)
    ) {
        return null;
    }

    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${ampm}`;
    }

    convertTo24HourFormat(timeString: string | null | undefined): string | null {
    if (!timeString) {
        return null;
    }

    const parts = timeString.trim().split(' ');

    if (parts.length !== 2) {
        return null;
    }

    const [time, modifier] = parts;

    const timeParts = time.split(':');

    if (timeParts.length < 2) {
        return null;
    }

    let hours = Number(timeParts[0]);
    const minutes = Number(timeParts[1]);

    if (
        Number.isNaN(hours) ||
        Number.isNaN(minutes)
    ) {
        return null;
    }

    if (modifier === 'PM' && hours < 12) {
        hours += 12;
    } else if (modifier === 'AM' && hours === 12) {
        hours = 0;
    }

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }

    setPatientAsSubscriber(): void {
    const controls = this.pRegisterForm.controls;

    if (controls.isSubscriber.value === true) {

        controls.subscriberFName.setValue(
            controls.firstName.value ?? null
        );

        controls.subscriberLName.setValue(
            controls.lastName.value ?? null
        );

        const dob = controls.dob.value;

        controls.subscriberDOB.setValue(
            dob
                ? this.datePipe.transform(
                    dob,
                    'MM/dd/yyyy'
                )
                : null
        );

    } else {

        controls.subscriberFName.setValue(null);
        controls.subscriberLName.setValue(null);
        controls.subscriberDOB.setValue(null);
    }
    }

    runBatchJob(): void {
    if (!this.patientId || this.isReEvaluating) {
        return;
    }

    this.isReEvaluating = true;

    const reqData = {
        patientId: this.patientId
    };

    this.patientService
        .runBatchJob(reqData)
        .pipe(
            first(),
            finalize(() => {
                this.isReEvaluating = false;
                this.cdr.detectChanges();
            })
        )
        .subscribe({
            next: () => {
                swal.fire({
                    title: 'Patient Evaluation Completed',
                    text: 'The patient has been successfully queued for re-evaluation.',
                    icon: 'success',
                    timer: 2500,
                    showConfirmButton: false
                });
            },

            error: (error) => {
                console.error('Error running batch job:', error);

                const message =
                    error?.error?.message ||
                    error?.message ||
                    'An error occurred while running the batch job.';

                swal.fire({
                    title: 'Re-evaluation Failed',
                    text: message,
                    icon: 'error',
                    timer: 3500,
                    showConfirmButton: false
                });
            }
        });
    }

    getAgents() {
      let params = {
        isWorkOrderUser: true,
        clientId: this.authService.getClientId()
      };
      this.patientService.getAgents(params).pipe(first()).subscribe(
        (response: any) => {
          if (response) {
            this.agentArray = response;
            // Add `fullName` property to each agent in `agentArray`
            this.agentArray = this.agentArray.map((agent: any) => ({
                ...agent,
                fullName: `${agent.firstName} ${agent.lastName}`
            }));

            // Initialize `filterAgentArray` with the updated `agentArray`
            this.filterAgentArray = [...this.agentArray];
            /* this.filterAgentArray = this.agentArray.filter(agent =>
                 `${agent.firstName} ${agent.lastName}`
                     .toLowerCase()
                     .includes(this.searchText.toLowerCase())
             );*/

          }
        });
    }

    onCancel(): void {
    if (this.isExternalUser) {
        this.route.navigate(['/home']);
        return;
    }

      this.route.navigate(['/patient']);
    }



    get medicalInsurance(): FormGroup {
        return this.pRegisterForm.get('medicalInsurance') as FormGroup;
    }

    get includesDental(): boolean {
        return this.pRegisterForm.get('benefitType')?.value !== 'MEDICAL';
    }

    get includesMedical(): boolean {
        return this.pRegisterForm.get('benefitType')?.value !== 'DENTAL';
    }

    private createMedicalInsurance(data: Partial<IMedicalInsurance> = {}): FormGroup {
        return this.fb.group({
            id: [data.id ?? null],
            insuranceType: [data.insuranceType || 'Primary', Validators.required],
            payerId: [data.payer?.id ?? null, Validators.required],
            groupNo: [data.groupNo || null],
            groupName: [data.groupName || null],
            planName: [data.planName || 'NO_PLAN'],
            insuranceId: [data.insuranceId || null],
            networkType: [data.networkType || 'In-Network'],
            formType: [data.formType || 'SHORT FORM'],
            planType: [data.planType || 'PPO'],
            planCreation: [data.planCreation || 'NO'],
            eligible: [data.eligible !== false],
            addOn: [data.addOn === true],
            employerName: [data.employerName || null],
            claimsAddress: [data.claimsAddress || null],
            preAuthorizeAddress: [data.preAuthorizeAddress || null],
            relationWithSubscriber: [data.relationWithSubscriber || 'SELF'],
            coveragePlan: [data.coveragePlan || null],
            maxed: [data.maxed === true]
        });
    }

    onBenefitTypeChange(value: PatientBenefitType): void {
        for (const name of ['payer','insuranceType']) {
            const control = this.pRegisterForm.get(name);
            if (value === 'MEDICAL') { control?.clearValidators(); }
            else { control?.setValidators(Validators.required); }
            control?.updateValueAndValidity({emitEvent: false});
        }
        if (value === 'DENTAL') {
            this.medicalInsurance.disable({emitEvent: false});
        } else {
            this.medicalInsurance.enable({emitEvent: false});
        }
        this.pRegisterForm.updateValueAndValidity({emitEvent: false});
    }

    private buildMedicalInsurance(): IMedicalInsurance | null {
        if (!this.includesMedical) { return null; }
        const value = this.medicalInsurance.getRawValue();
        return this.cleanNulls({
            id: value.id || undefined,
            insuranceType: value.insuranceType,
            payer: {id: Number(value.payerId)},
            groupNo: value.groupNo,
            groupName: value.groupName,
            planName: value.planName || 'NO_PLAN',
            insuranceId: value.insuranceId,
            networkType: value.networkType,
            formType: value.formType,
            planType: value.planType,
            planCreation: value.planCreation,
            eligible: value.eligible,
            addOn: value.addOn,
            employerName: value.employerName,
            claimsAddress: value.claimsAddress,
            preAuthorizeAddress: value.preAuthorizeAddress,
            relationWithSubscriber: value.relationWithSubscriber,
            coveragePlan: value.coveragePlan,
            maxed: value.maxed
        });
    }

    // Register client function / update
    onRegister(): any {
        this.pRegisterForm.markAllAsTouched();
        const benefitType: PatientBenefitType = this.pRegisterForm.get('benefitType')?.value || 'DENTAL';
        if (this.patientId && this.existingMedicalInsurance && benefitType === 'DENTAL') {
            this.showError('Removing an existing Medical insurance record is not supported by the patient update API. Keep Both or Medical for this update.');
            return;
        }
        if (this.patientId && this.existingDentalInsurance && benefitType === 'MEDICAL') {
            this.showError('Removing an existing Dental insurance record is not supported by the current patient update API. Keep Both or Dental for this update.');
            return;
        }
        if (this.pRegisterForm.valid) {
            let reqData: IPatient = {
                // PatientBenefitType is derived by the backend from insurance records.
                medicalInsurance: this.includesMedical ? this.buildMedicalInsurance() : undefined,
                firstName: this.pRegisterForm.controls.firstName.value ? this.pRegisterForm.controls.firstName.value : null,
                lastName: this.pRegisterForm.controls.lastName.value ? this.pRegisterForm.controls.lastName.value : null,
                gender: this.pRegisterForm.controls.gender.value ? this.pRegisterForm.controls.gender.value : null,
                dob: this.pRegisterForm.controls.dob.value ? this.datePipe.transform(this.pRegisterForm.controls.dob.value, 'MM-dd-yyyy') : null,
                ssn: this.pRegisterForm.controls.ssn.value ? this.pRegisterForm.controls.ssn.value : null,
                contact: this.getCleanedContact( {
                    email: this.pRegisterForm.controls.email.value ? this.pRegisterForm.controls.email.value : null,
                    phones: [
                        {
                            phoneType: this.pRegisterForm.controls.phoneType.value ? this.pRegisterForm.controls.phoneType.value : null,
                            number: this.pRegisterForm.controls.number.value ? this.pRegisterForm.controls.number.value : null,
                        }
                    ]
                }),
                address: this.cleanNulls( {
                    firstLine: this.pRegisterForm.controls.firstLine.value ? this.pRegisterForm.controls.firstLine.value : null,
                    secondLine: this.pRegisterForm.controls.secondLine.value ? this.pRegisterForm.controls.secondLine.value : null,
                    city: this.pRegisterForm.controls.city.value ? this.pRegisterForm.controls.city.value : null,
                    zip: this.pRegisterForm.controls.zip.value ? this.pRegisterForm.controls.zip.value : null,
                    state: this.pRegisterForm.controls.state.value ? this.pRegisterForm.controls.state.value : null,
                }),
                primaryIns: this.includesDental ? this.cleanNulls( {
                    formType: this.pRegisterForm.controls.formType.value ? this.pRegisterForm.controls.formType.value : null,
                    payer: {id: this.pRegisterForm.controls.payer.value ? this.pRegisterForm.controls.payer.value : null},
                    groupNo: this.pRegisterForm.controls.groupNo.value ? this.pRegisterForm.controls.groupNo.value : null,
                    groupName: this.pRegisterForm.controls.groupName.value ? this.pRegisterForm.controls.groupName.value : null,
                    planName: 'NO_PLAN',
                    planType: 'PPO',
                    planCreation: 'NO',
                    relationWithSubscriber: this.pRegisterForm.controls.relationship.value || 'SELF',

                    // providerName: null,
                    insuranceType: this.pRegisterForm.controls.insuranceType.value ? this.pRegisterForm.controls.insuranceType.value : null,
                    contact: this.getCleanedContact( {
                        phones: [
                            {
                                number: this.pRegisterForm.controls.insurancePhoneNo.value ? this.pRegisterForm.controls.insurancePhoneNo.value : null,
                            }
                        ]
                    }),
                }) : undefined,
                bookedSlots: [
                    {
                        timeSlot: {
                            date:  this.pRegisterForm.controls.appointmentDate.value ? this.datePipe.transform(this.pRegisterForm.controls.appointmentDate.value, 'MM-dd-yyyy') : null,
                            startTime: this.pRegisterForm.controls.appointmentTime.value ? this.formatTimeTo12Hour(this.pRegisterForm.controls.appointmentTime.value) : null,
                        }
                    }
                ],
                subscriber:{
                    firstName: this.pRegisterForm.controls.subscriberFName.value ? this.pRegisterForm.controls.subscriberFName.value : null,
                    lastName: this.pRegisterForm.controls.subscriberLName.value ? this.pRegisterForm.controls.subscriberLName.value : null,
                    dob: this.pRegisterForm.controls.subscriberDOB.value ? this.pRegisterForm.controls.subscriberDOB.value ? this.datePipe.transform(this.pRegisterForm.controls.subscriberDOB.value, 'MM-dd-yyyy') :null : null,

                },
                memberId: this.pRegisterForm.controls.memberId.value ? this.pRegisterForm.controls.memberId.value : null,
                relationship: this.pRegisterForm.controls.relationship.value ? this.pRegisterForm.controls.relationship.value : null,
                providerId: this.pRegisterForm.controls.providerId.value ? this.pRegisterForm.controls.providerId.value : null,
                isSubscriber: this.pRegisterForm.controls.isSubscriber.value ? this.pRegisterForm.controls.isSubscriber.value : false,
                patientId:this.pRegisterForm.controls.patientId.value?this.pRegisterForm.controls.patientId.value:null,
                clientId : this.authService.clientId ? this.authService.clientId : null,
                officeId : this.pRegisterForm.controls.officeId.value ? this.pRegisterForm.controls.officeId.value : null,
                userId : this.pRegisterForm.controls.userId.value ? this.pRegisterForm.controls.userId.value : null,
                urgency : this.isExternalUser ? 'URGENT': this.pRegisterForm.controls.urgency.value ? this.pRegisterForm.controls.urgency.value : null
                // reRunBatchJob: this.pRegisterForm.controls.reRunBatchJob.value ? this.pRegisterForm.controls.reRunBatchJob.value :null,


            };
            // On existing records the backend synchronizes medical insurance entries by type.
            // The update endpoint does not clear existing insurance records when a field is omitted or null.
            if (!this.includesDental) { delete reqData.primaryIns; }
            // update logic
            if (this.patientId) {
                let params = {
                    patientId: this.patientId,
                    active: this.status
                };
                this.patientService.updatePatient(reqData, params).pipe(first()).subscribe(
                    (response: any) => {
                        if (response != undefined) {
                            if (this.isExternalUser) {
                                this.route.navigate(['/home']);
                                return;
                            }

                            this.route.navigate(['/patient']);
                            
                            swal.fire({
                                icon: 'success',
                                text: 'Patient :- ' + `" ${reqData.firstName} "` + ' updated successfully.',
                                showConfirmButton: false,
                                timer: 3000
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: response.message,
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                );
            }
            // add / register logic
            else {
                this.patientService.patientRegistration(reqData).pipe(first()).subscribe(
                    (response: any) => {
                        if (response != undefined) {
                            if (this.isExternalUser) {
                                this.route.navigate(['/home']);
                                return;
                            }
                            this.route.navigate(['patient']);
                            swal.fire({
                                icon: 'success',
                                text: 'Patient :- ' + `" ${reqData.firstName} "` + ' registered successfully.',
                                showConfirmButton: false,
                                timer: 3000
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: response.message,
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                );
            }

        }
    }

    // Helper function to clean null values from objects
    private cleanNulls(obj: any): any {
        const cleanedObj = { ...obj };
        Object.keys(cleanedObj).forEach(key => {
            if (cleanedObj[key] === null || cleanedObj[key] === undefined) {
                delete cleanedObj[key];
            }
        });
        // Return undefined if the object is empty after cleaning (this skips adding the object to reqData)
        return Object.keys(cleanedObj).length ? cleanedObj : undefined;
    }

    private getCleanedContact(contact: any): any {
    contact.phones = Array.isArray(contact?.phones)
        ? contact.phones.filter(
            (phone: Phone) => !!(phone?.phoneType || phone?.number)
        )
        : [];

    if (!contact?.email && contact.phones.length === 0) {
        return null;
    }

    return this.cleanNulls(contact);
    }


}
